
export class CCQConfigurationForEmployee {
  employeeId: string;
  active = true;
  workedHourCode = '25';
  secteur: string;
  metier: string;
  annexe: string;
  apprenti: string;
  local: string;
  region: string;
}
